import { getDefaultExportFromCjs } from " commonjsHelpers.js";
import { __require as requireBundle } from "C:\\xampp\\htdocs\\eleven\\wp-content\\themes\\eleven\\src\\js\\bundle\\index.js";
var bundleExports = requireBundle();
export { bundleExports as __moduleExports };
export default /*@__PURE__*/getDefaultExportFromCjs(bundleExports);